import {React,useEffect, useState} from 'react';
import Popup from './Popup';
import Widgets from './Widgets';
import { useLocation } from 'react-router-dom';
//import { useParams } from 'react-router-dom';
import Invoice from './Invoice';

function RootWrapper({ activeTheme, darkmode, clientName, font, language, setActiveTheme, selectedLayout, carbon, rating, addcss,  brandColor,  seasonBrand,ProductCount,print}) {
    const { search } = useLocation();
    const params = new URLSearchParams(search);

const [grandTotal, setGrandTotal] = useState(0);
  const handleGrandTotal = (value) => {
    setGrandTotal(value);
  };

  activeTheme = activeTheme || params.get('color') || "yellow";
  language = language || params.get('language') || "english";
  clientName = clientName || params.get('clientName') || "apparel";
  selectedLayout = selectedLayout || params.get('layout') || "layout-featured";

  font = font || params.get('font') || "fira";
  if (carbon === undefined || carbon === null) {
    carbon = params.get('carbon') || "1";
  }
  if (rating === undefined || rating === null) {
    rating = params.get('rating') || "1";
  }
  addcss = addcss || params.get('addcss') || "0";
  brandColor = brandColor || params.get('brandColor') || "0";
  ProductCount = ProductCount || params.get('ProductCount') || "3";
  print = print || params.get('print') || "";
  useEffect(() => {const timer = setTimeout(() => {
      if (print === 'layout-print') {
        window.print();
      }
  }, 1000);return () => clearTimeout(timer);}, [print]);
  return (
    <>
      <Popup 
        activeTheme={activeTheme} 
        clientName={clientName} 
        language={language} 
        font={font} 
        setActiveTheme={setActiveTheme} 
        selectedLayout={selectedLayout} 
        carbon={carbon} 
        rating={rating} 
         grandTotal={grandTotal}
      /> 
      <Invoice activeTheme={activeTheme} clientName={clientName} language={language} font={font} setActiveTheme={setActiveTheme} selectedLayout={selectedLayout} carbon={carbon} rating={rating} brandColor={brandColor} seasonBrand={seasonBrand} ProductCount={ProductCount} onGrandTotal={handleGrandTotal}/>
      <Widgets 
        activeTheme={activeTheme} 
        clientName={clientName} 
        font={font} 
        language={language} 
        setActiveTheme={setActiveTheme} 
        selectedLayout={selectedLayout} 
        carbon={carbon} 
        rating={rating} 
        addcss={addcss} 
      />
    </>
  );
}

export default RootWrapper;